module.exports = __webpack_public_path__ + "img/triangle.3303e6e8.png";